.presetPreview {
  width: auto;
  max-height: 400px;
  border-radius: 8px;
  cursor: pointer;
}

.presetPreviewFull {
  border-radius: 8px;
  width: auto;
  height: 70vh;
  cursor: pointer;
}